<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12>
        <v-card class="mx-auto mt-10 mb-5" max-width="50%" color="success" dark>
          <v-card-title class="headline" v-if="page_title">{{ page_title }}</v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <div id="klarna-checkout-container"></div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "KlarnaCheckoutOrderConfirmation",

  props: ["id", "locale"],

  data() {
    return {
      page_title: null,
      order: null
    }
  },

  created() {
    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    axios
      .post(this.API_URL + "klarna/update-enrolments", {
        id: this.id
      })
      .then((res) => {
        axios
          .get(this.API_URL + "klarna/checkout/get-order/" + this.id)
          .then((res) => {
            this.order = res.data
            this.checkout_render_html(this.order.html_snippet)
          })
          .catch((err) => console.log(err))
      })
      .catch((err) => console.log(err))
  },
  methods: {
    checkout_render_html(htmlSnippet) {
      var checkoutContainer = document.getElementById("klarna-checkout-container")
      checkoutContainer.innerHTML = htmlSnippet
      var scriptsTags = checkoutContainer.getElementsByTagName("script")
      // This is necessary otherwise the scripts tags are not going to be evaluated
      for (var i = 0; i < scriptsTags.length; i++) {
        var parentNode = scriptsTags[i].parentNode
        var newScriptTag = document.createElement("script")
        newScriptTag.type = "text/javascript"
        newScriptTag.text = scriptsTags[i].text
        parentNode.removeChild(scriptsTags[i])
        parentNode.appendChild(newScriptTag)
      }

      if (this.order.completed_at) {
        this.page_title = this.$t("fe.enrolment.enrolment_success_klarna", {
          date: this.moment(this.order.completed_at).format(this.DATE_FORMAT + " " + this.TIME_FORMAT)
        })
      }
    }
  }
}
</script>
